import BaseEvent from "../util/baseEvent"
import { ENGINE, LIVE } from "../util/eventTypes"
import { getMediaEnterParams } from "../util/getEnterParams"
import { getVendorCore } from "../util/getVendorCore"

let isPlay = false
class Media extends BaseEvent {
  async enterRoom(authInfo) {
    let { vendor } = authInfo
    this.$logger.setPrefix("media:" + vendor)
    this.$logger.info(ENGINE.MEDIA_ENTER_WEBSERVER_SUCCESS)

    let VendorCore = getVendorCore(vendor)
    this.engine = new VendorCore()
    let enterParams = getMediaEnterParams(vendor, authInfo)
    try {
      let res = await this.engine.enterRoom(enterParams)
      if (res && res.status === 1) {
        this.$logger.info(LIVE.ENTER_LIVE_ROOM_SUCCESS, res)
        this.initEvent()
        return res
      }
    } catch (res) {
      this.$logger.error(LIVE.ENTER_LIVE_ROOM_FAIL, res)
      return Promise.reject("enterRoom :" + res)
    }
  }
  async exitRoom() {
    this.destroy()
    if (isPlay) {
      this.closeMedial()
    }
    try {
      let res = await this.engine.exitRoom()
      this.$logger.info(LIVE.EXIT_LIVE_ROOM_SUCCESS)
      return res
    } catch (error) {
      this.$logger.error(LIVE.EXIT_LIVE_ROOM_FAIL, "exitRoom :" + error)
      return Promise.reject("exitRoom :" + error)
    }
  }
  async getDeviceList() {
    try {
      let res = await this.engine.getDeviceList()
      this.$logger.info(LIVE.GET_DEVICE_SUCCESS, res)
      return res
    } catch (error) {
      this.$logger.error(LIVE.GET_DEVICE_FAIL, "getDeviceList :" + error)
      return Promise.reject("getDeviceList :" + error)
    }
  }
  async getMedialStream(config) {
    try {
      let res = await this.engine.getMedialStream(config)
      this.$logger.info(LIVE.GET_MEDIASTREAM_SUCCESS, res)
      return res
    } catch (error) {
      this.$logger.error(LIVE.GET_MEDIASTREAM_FAIL, "getMedialStream :" + error)
      return Promise.reject("getMedialStream :" + error)
    }
  }
  async getShowMedialStream(config) {
    try {
      let res = await this.engine.getShowMedialStream(config)
      this.$logger.info(LIVE.GET_SHOW_MEDIASTREAM_SUCCESS, res)
      return res
    } catch (error) {
      this.$logger.error(
        LIVE.GET_SHOW_MEDIASTREAM_FAIL,
        "getShowMedialStream :" + error
      )
      return Promise.reject("getShowMedialStream :" + error)
    }
  }
  async publishMedialStream(stream, options) {
    try {
      await this.engine.publishMedialStream(stream, options)
      this.$logger.info(LIVE.PUBLISH_MEDIASTREAM_SUCCESS)
      return stream
    } catch (error) {
      this.$logger.error(
        LIVE.PUBLISH_MEDIASTREAM_FAIL,
        "publishMedialStream :" + error
      )
      return Promise.reject("publishMedialStream :" + error)
    }
  }
  async unpublishMedialStream(stream) {
    try {
      let res = await this.engine.unpublishMedialStream(stream)
      this.$logger.info(LIVE.UN_PUBLISH_MEDIASTREAM_SUCCESS)
      return res
    } catch (error) {
      this.$logger.error(
        LIVE.UN_PUBLISH_MEDIASTREAM_FAIL,
        "unpublishMedialStream :" + error
      )
      return Promise.reject("unpublishMedialStream :" + error)
    }
  }
  async playMedial(options) {
    try {
      await this.engine.playMedial(options)
      isPlay = true
      this.$logger.info(LIVE.PLAY_MEDIA_SUCCESS)
    } catch (error) {
      this.$logger.error(LIVE.PLAY_MEDIA_FALIED, "playMedial :" + error)
      return Promise.reject("playMedial :" + error)
    }
  }
  // async playShowMedia(options) {
  //   try {
  //     await this.engine.playShowMedia(options)
  //   } catch (error) {
  //     return Promise.reject("playShowMedia :" + error)
  //   }
  // }
  closeMedial(stream) {
    return new Promise((resolve, reject) => {
      this.engine
        .closeMedial(stream)
        .then(() => {
          isPlay = false
          this.$logger.info(LIVE.CLOSE_MEDIA_SUCCESS)
          resolve()
        })
        .catch(err => {
          reject(new Error("关闭媒体" + err))
        })
    })
  }
  enableVideo(stream) {
    return new Promise((resolve, reject) => {
      this.engine
        .enableVideo(stream)
        .then(streamObj => {
          this.$logger.info(LIVE.ENABLE_VIDEO_SUCCESS)
          resolve(streamObj)
        })
        .catch(err => {
          reject(new Error("打开视频失败" + err))
        })
    })
  }
  disableVideo(stream) {
    return new Promise((resolve, reject) => {
      this.engine
        .disableVideo(stream)
        .then(streamObj => {
          this.$logger.info(LIVE.DISABLED_VIDEO_SUCCESS)
          resolve(streamObj)
        })
        .catch(err => {
          reject(new Error("关闭视频失败" + err))
        })
    })
  }
  enableAudio(stream) {
    return new Promise((resolve, reject) => {
      this.engine
        .enableAudio(stream)
        .then(streamObj => {
          this.$logger.info(LIVE.ENABLE_AUDIO_SUCCESS)
          resolve(streamObj)
        })
        .catch(err => {
          reject(new Error("enableAudio fail" + err))
        })
    })
  }
  disableAudio(stream) {
    return new Promise((resolve, reject) => {
      this.engine
        .disableAudio(stream)
        .then(streamObj => {
          this.$logger.info(LIVE.DISABLED_AUDIO_SUCCESS)
          resolve(streamObj)
        })
        .catch(err => {
          reject(new Error("disableAudio fail" + err))
        })
    })
  }
  subscribeMedialStream() {
    return new Promise((resolve, reject) => {
      this.engine
        .subscribeMedialStream()
        .then(() => {
          this.$logger.info(LIVE.SUBSCRIBE_MEDIASTREAM_SUCCESS)
          resolve()
        })
        .catch(err => {
          this.$logger.error(
            LIVE.SUBSCRIBE_MEDIASTREAM_FAIL,
            "subscribeMedialStream fail" + err
          )
          reject(new Error("subscribeMedialStream fail" + err))
        })
    })
  }
  getAudioLevel(stream) {
    return new Promise((resolve, reject) => {
      this.engine
        .getAudioLevel(stream)
        .then(() => {
          this.$logger.info(LIVE.GET_AUDIO_LEVEL_SUCCESS)
          resolve()
        })
        .catch(err => {
          reject(new Error("获取音量失败" + err))
        })
    })
  }
  getStreamStats(stream) {
    return this.engine.getStreamStats(stream)
  }
  getLocalStream() {
    return this.engine.getLocalStream()
  }
  // 检测浏览兼容
  checkSystemRequirements() {
    return this.engine.checkSystemRequirements
  }
  initEvent() {
    /* ————————————————————————————————————直播消息———————————————————————————————— */
    // 有流发布
    this.engine.on("STREAM_PUBLISHED", data => {
      this.emit("STREAM_PUBLISHED", data)
      this.$logger.info("STREAM_PUBLISHED")
    })
    // 有流取消发布
    this.engine.on("STREAM_UNPUBLISHED", data => {
      this.emit("STREAM_UNPUBLISHED", data)
      this.$logger.info("STREAM_UNPUBLISHED")
    })
    // 视频打开
    this.engine.on("VIDEO_OPEN", data => {
      this.emit("VIDEO_OPEN", data)
      this.$logger.info("VIDEO_OPEN")
    })
    // 视频关闭
    this.engine.on("VIDEO_CLOSE", data => {
      this.emit("VIDEO_CLOSE", data)
      this.$logger.info("VIDEO_CLOSE")
    })
    // 客户端离开
    this.engine.on("CLIENT_LEAVE", data => {
      this.emit("CLIENT_LEAVE", data)
      this.$logger.info("CLIENT_LEAVE")
    })
    // 音频打开
    this.engine.on("AUDIO_OPEN", data => {
      this.emit("AUDIO_OPEN", data)
      this.$logger.info("AUDIO_OPEN")
    })
    // 音频关闭
    this.engine.on("AUDIO_CLOSE", data => {
      this.emit("AUDIO_CLOSE", data)
      this.$logger.info("AUDIO_CLOSE")
    })

    // 房间ws媒体连接异常
    this.engine.on("ROOM_DISCONNECTED", data => {
      this.emit("ROOM_DISCONNECTED", data)
      this.$logger.error("ROOM_DISCONNECTED", data)
    })
  }
  destroy() {
    this.engine.removeAllListeners()
  }
}
export default Media
